export default {
      id: "sli-info-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.43681d49.svg#sli-info",
      toString: function () {
        return this.url;
      }
    }